import {calculateAvailableTrapSetupCells} from "./goblins/calculateAvailableTrapSetupCells";
import {calculateAvailableTrapRemovalCells} from "./goblins/calculateAvailableTrapRemovalCells";
import {calculateAvailableBuildingDamageCells} from "./goblins/calculateAvailableBuildingDamageCells";
import {GOBLINS_TRAP_SETUP_COST} from "../../configs/factions/goblins";

/**
 * Может ли отряд гоблинов применить ХОТЬ ОДНУ из трёх способностей прямо
 * сейчас. Не дублирует проверки годности отряда (фракция/флаг/размер/
 * зажатость/прямая видимость) — они уже сделаны внутри каждой из трёх
 * calculateAvailable* функций, единственных источников истины (см.
 * design.md). Здесь — только ИЛИ по трём способностям плюс проверка монет для
 * установки ловушки (эта проверка не входит в calculateAvailableTrapSetupCells,
 * т.к. она о ресурсах игрока, а не о годности гексов).
 */
export const checkIfGoblinsUnitCouldUseAbility = (
  selectedUnit, units, playerCoins, hexes, citiesCache, specialBuildings, buildingsDamage, goblinsTraps, currentPlayer,
  fortressesUnderConstruction
) => {
  if (calculateAvailableTrapRemovalCells(
    units, goblinsTraps, selectedUnit, hexes, specialBuildings, buildingsDamage, fortressesUnderConstruction
  ).length > 0) {
    return true;
  }

  if (calculateAvailableBuildingDamageCells(
    hexes, citiesCache, specialBuildings, buildingsDamage, units, selectedUnit, currentPlayer, fortressesUnderConstruction
  ).length > 0) {
    return true;
  }

  if (playerCoins >= GOBLINS_TRAP_SETUP_COST
    && calculateAvailableTrapSetupCells(
      hexes, units, goblinsTraps, selectedUnit, specialBuildings, buildingsDamage, fortressesUnderConstruction
    ).length > 0) {
    return true;
  }

  return false;
};
